import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ClientDto } from "../../../../core/models/client/details/clientDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { DeleteCustomerAddressRequestDto } from "../../../../core/models/client/deleteCustomerAddressRequestDto";
import { DrawerModule } from "primeng/drawer";
import { CommonModule } from "@angular/common";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ClientDetailsService } from "../../../../core/services/client-details.service";
import { Address } from "../../../../core/models/shared/address";

@UntilDestroy()
@Component({
  selector: "jni-view-address-information",
  templateUrl: "./view-address-information.component.html",
  styleUrls: ["./view-address-information.component.scss"],
  imports: [CommonModule, DrawerModule],
  encapsulation: ViewEncapsulation.None,
})
export class ViewAddressInformationComponent implements OnInit {
  @Output() displayChange = new EventEmitter<boolean>();
  @Input() display!: boolean;
  @Output() editEvent = new EventEmitter<Address>();
  clientInformation?: ClientDto;
  clientId = "";
  clientAddressInformation?: Address[] = [];
  @Output() refreshGrid = new EventEmitter<boolean>();

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("clientIdFromModal")
  set clientIdFromModal(value: string) {
    this.clientId = value;
  }

  constructor(
    private _loaderService: LoaderService,
    private _clientDetailsService: ClientDetailsService,
    private router: ActivatedRoute,
    private _toastr: JniToastrService
  ) {
    this.router.params.subscribe((params: Params) => {
      this.clientId = params["id"];
    });
  }

  ngOnInit(): void {
    this.getClientInformationData();
  }

  onHide() {
    this.displayChange.emit(false);
  }

  getClientInformationData() {
    if (this.clientId) {
      this._loaderService.setLoaderState(true);
      this._clientDetailsService
        .getClientInformation(this.clientId?.toString())
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.clientInformation = res.data;
              this.clientAddressInformation =
                this.clientInformation?.clientAddress;
            }
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  openEditAddress(event: Address) {
    this.editEvent.emit(event);
  }

  deleteCustomerAddress(item: Address) {
    this._loaderService.setLoaderState(true);

    const obj: DeleteCustomerAddressRequestDto = {
      postalAddress: item.postalAddressD365,
      partyNumber: item.partyNumberD365,
    };

    this._clientDetailsService
      .deleteCustomerAddress(obj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            this._toastr.success(
              "Success",
              res.message || "Address deleted successfully"
            );
            this.getClientInformationData();
            this.refreshGrid.emit(true);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error Deleting Address"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error Deleting Address");
        },
      });
  }

  extractRoles(role: string | undefined) {
    return role ? role.split(";").join(" ") : "";
  }
}
